<script lang="ts">
    import { Chip } from 'svelte-materialify/src';
    const chipColors = {
        A: 'purple',
        B: 'teal',
        C: 'indigo',
        D: 'deep-orange'
    };

    export let value: string;
</script>

<!-- <Chip class="{chipColors[value[0]]} white-text" size="small">{value}</Chip> -->
<span class="text-body-2">{value}</span>